/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestGatewayInfoBrowserInfo
 */
export interface CreateReservationRequestGatewayInfoBrowserInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    acceptHeader: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    colorDepth: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    language: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    javaEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    screenHeight: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    screenWidth: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    userAgent: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestGatewayInfoBrowserInfo
     */
    timeZoneOffset: number;
}

/**
 * Check if a given object implements the CreateReservationRequestGatewayInfoBrowserInfo interface.
 */
export function instanceOfCreateReservationRequestGatewayInfoBrowserInfo(value: object): value is CreateReservationRequestGatewayInfoBrowserInfo {
    if (!('acceptHeader' in value) || value['acceptHeader'] === undefined) return false;
    if (!('colorDepth' in value) || value['colorDepth'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('javaEnabled' in value) || value['javaEnabled'] === undefined) return false;
    if (!('screenHeight' in value) || value['screenHeight'] === undefined) return false;
    if (!('screenWidth' in value) || value['screenWidth'] === undefined) return false;
    if (!('userAgent' in value) || value['userAgent'] === undefined) return false;
    if (!('timeZoneOffset' in value) || value['timeZoneOffset'] === undefined) return false;
    return true;
}

export function CreateReservationRequestGatewayInfoBrowserInfoFromJSON(json: any): CreateReservationRequestGatewayInfoBrowserInfo {
    return CreateReservationRequestGatewayInfoBrowserInfoFromJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoBrowserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestGatewayInfoBrowserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptHeader': json['acceptHeader'],
        'colorDepth': json['colorDepth'],
        'language': json['language'],
        'javaEnabled': json['javaEnabled'],
        'screenHeight': json['screenHeight'],
        'screenWidth': json['screenWidth'],
        'userAgent': json['userAgent'],
        'timeZoneOffset': json['timeZoneOffset'],
    };
}

export function CreateReservationRequestGatewayInfoBrowserInfoToJSON(json: any): CreateReservationRequestGatewayInfoBrowserInfo {
    return CreateReservationRequestGatewayInfoBrowserInfoToJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoBrowserInfoToJSONTyped(value?: CreateReservationRequestGatewayInfoBrowserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptHeader': value['acceptHeader'],
        'colorDepth': value['colorDepth'],
        'language': value['language'],
        'javaEnabled': value['javaEnabled'],
        'screenHeight': value['screenHeight'],
        'screenWidth': value['screenWidth'],
        'userAgent': value['userAgent'],
        'timeZoneOffset': value['timeZoneOffset'],
    };
}

